import { Inertia } from '@inertiajs/inertia'
import { LoadingBar } from 'quasar'

let timeout = null

Inertia.on('start', () => {
  timeout = setTimeout(() => LoadingBar.start(), 200)
})

Inertia.on('finish', () => {
  clearTimeout(timeout)
  LoadingBar.stop()
})

Inertia.on('progress', event => {
  if (event.detail.progress.percentage) {
    LoadingBar.increment((event.detail.progress.percentage / 100) * 0.9)
  }
})
